import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createGetCytoThunk, createInitialCytoState } from '../../common/cytoSliceCommons'
import { TCytoField, TCytoStep, TMemCytoData } from '../../data/CytoData'
import { RunState } from './RunStore'
import { saveCytoAsync } from './saveThunk'

export const getCytoAsync = createGetCytoThunk('cytodata/fetchCytoData')
const initialState = createInitialCytoState()

export interface ICytoSetFieldPayload {
    step: TCytoStep
    fieldName: TCytoField
    value: number
}

export const cytoSlice = createSlice({
    name: 'cytodata',
    initialState: initialState,
    reducers: {
        setfield: (state, action: PayloadAction<ICytoSetFieldPayload>) => {
            state.data[action.payload.step][action.payload.fieldName] = action.payload.value
        },
        replaceCytoData: (state, action: PayloadAction<TMemCytoData>) => {
            state.data = action.payload
            state.status = 'idle'
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCytoAsync.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getCytoAsync.fulfilled, (state, action) => {
                state.status = 'idle'
                state.data = action.payload!
            })
            .addCase(saveCytoAsync.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(saveCytoAsync.fulfilled, (state) => {
                state.status = 'idle'
                // TODO: process result - react on error
            })
    }
})

export const selectCyto = (state: RunState) => state.cytoSlice.data
export const { setfield, replaceCytoData } = cytoSlice.actions

export default cytoSlice.reducer